import { useCallback } from 'react';

import { useShallow } from 'zustand/react/shallow';

import { useGlobalBottomSheetStore } from '@south-street-app/stores';

const useMaintenanceModal = () => {
  const { openBottomSheet, closeBottomSheet } = useGlobalBottomSheetStore(
    useShallow((state) => ({
      openBottomSheet: state.openBottomSheet,
      closeBottomSheet: state.closeBottomSheet,
    })),
  );

  const toggleMaintenanceModal = useCallback(
    (showMaintenanceModal: boolean) => {
      if (showMaintenanceModal) {
        setTimeout(() => {
          openBottomSheet({
            type: 'maintenance',
          });
        }, 200);
      } else {
        closeBottomSheet();
      }
    },
    [openBottomSheet, closeBottomSheet],
  );

  return toggleMaintenanceModal;
};

export { useMaintenanceModal };
